// CurriculumTabContent 관련 타입 정의
export const ItemTypes = {
    SECTION: 'section',
    LESSON: 'lesson'
};
// 임시 타입 정의 (실제로는 OpenAPI에서 생성된 타입을 사용해야 함)
export var LectureSummaryContentTypeEnum = /*#__PURE__*/ function(LectureSummaryContentTypeEnum) {
    LectureSummaryContentTypeEnum["Markdown"] = "Markdown";
    LectureSummaryContentTypeEnum["Video"] = "Video";
    LectureSummaryContentTypeEnum["Interactive"] = "Interactive";
    return LectureSummaryContentTypeEnum;
}({});
export var LectureSummaryPlatformSupportEnum = /*#__PURE__*/ function(LectureSummaryPlatformSupportEnum) {
    LectureSummaryPlatformSupportEnum["IdeAndWeb"] = "IdeAndWeb";
    LectureSummaryPlatformSupportEnum["WebOnly"] = "WebOnly";
    LectureSummaryPlatformSupportEnum["IdeOnly"] = "IdeOnly";
    return LectureSummaryPlatformSupportEnum;
}({});
